export const Logo = ({ light = false, size = "default", href = "#home", className = "" }) => (
  <a href={href} className={`inline-flex items-center ${className}`} data-testid="brand-logo">
    <span className="overflow-hidden rounded-xl bg-white p-1.5 shadow-sm ring-1 ring-black/5">
      <img
        src="/logo.png"
        alt="R.O.K Motors – Towing & Shipping"
        className={`block w-auto ${size === "sm" ? "h-8" : "h-11"}`}
      />
    </span>
  </a>
);

export const FlagPair = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="flag-pair">
    {/* USA */}
    <span className="relative h-4 w-6 overflow-hidden rounded-[3px] shadow ring-1 ring-black/10">
      <span className="absolute inset-0 bg-white" />
      <span className="absolute inset-0" style={{ background: "repeating-linear-gradient(180deg,#B22234 0 2px,#fff 2px 4px)" }} />
      <span className="absolute left-0 top-0 h-2 w-2.5 bg-[#3C3B6E]" />
    </span>
    <span className="text-xs font-bold text-current opacity-70">→</span>
    {/* Ghana */}
    <span className="relative h-4 w-6 overflow-hidden rounded-[3px] shadow ring-1 ring-black/10 flex flex-col">
      <span className="flex-1 bg-[#CE1126]" />
      <span className="flex-1 bg-[#FCD116] relative flex items-center justify-center">
        <span className="absolute text-[7px] leading-none text-black">★</span>
      </span>
      <span className="flex-1 bg-[#006B3F]" />
    </span>
  </span>
);
